var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FBBC05"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4851 10C13.3507 10 9.99902 13.2216 9.99902 17.1952C9.99902 21.1688 13.3507 24.3908 17.4851 24.3908C21.6195 24.3908 24.9707 21.1692 24.9707 17.1952C24.9707 13.2212 21.6195 10 17.4851 10ZM17.4851 22.266C14.5762 22.266 12.2096 19.9912 12.2096 17.1952C12.2096 14.3992 14.5762 12.1244 17.4851 12.1244C20.3939 12.1244 22.7606 14.3992 22.7606 17.1952C22.7606 19.9912 20.3939 22.266 17.4851 22.266Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4858 15.6112C16.5757 15.6112 15.8379 16.3204 15.8379 17.1956C15.8379 18.0708 16.5757 18.7796 17.4858 18.7796C18.3959 18.7796 19.1338 18.0704 19.1338 17.1956C19.1338 16.3208 18.3959 15.6112 17.4858 15.6112ZM17.4858 18.7668C16.5845 18.7668 15.8508 18.062 15.8508 17.1952C15.8508 16.3284 16.5845 15.624 17.4858 15.624C18.3872 15.624 19.1205 16.3288 19.1205 17.1952C19.1205 18.0616 18.3872 18.7668 17.4858 18.7668Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4865 13.8744C15.5814 13.8744 14.0312 15.364 14.0312 17.1952C14.0312 19.0264 15.5814 20.5164 17.4865 20.5164C19.3916 20.5164 20.9418 19.0264 20.9418 17.1952C20.9418 15.364 19.3916 13.8744 17.4865 13.8744ZM17.4865 18.7796C16.5764 18.7796 15.8386 18.0704 15.8386 17.1956C15.8386 16.3208 16.5764 15.6112 17.4865 15.6112C18.3966 15.6112 19.1345 16.3204 19.1345 17.1956C19.1345 18.0708 18.3966 18.7796 17.4865 18.7796Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9461 22.1176L24.4059 23.3808L23.2553 24.6084L21.6211 23.1936",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2557 24.6084L22.9736 24.9092C22.5312 25.3812 22.5707 26.1084 23.0618 26.5332L26.4946 29.5052C27.3161 30.2164 28.582 30.1528 29.3223 29.3632L29.4209 29.258C30.2532 28.37 30.1787 27.0012 29.2549 26.2016L25.5907 23.0292C25.3298 22.8032 24.9278 22.8236 24.6931 23.0744L24.4064 23.3804",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGlass);
export default __webpack_public_path__ + "static/media/ActiveGlass.6d1e667ac0d4973fb1bc8681afe5055c.svg";
export { ForwardRef as ReactComponent };